import { ENV, ENV_ENUM } from './env';

const FULL_EVENT_TYPE_OPTIONS = ['Brady', 'Tachy', 'AFib', 'Pause', 'Auto', 'Sinus'];

const STUDY_TYPE = {
  MCT: 'MCT',
  MCT_PEEK: 'MCT PEEK',
  CARDIAC_EVENT: 'CARDIAC EVENT',
  HOLTER: 'HOLTER',
  EXTENDED_HOLTER: 'EXTENDED HOLTER',
  HOLTER_AND_FOLLOW_ON_STUDY: 'HOLTER AND FOLLOW ON STUDY',
};

const INPUT_TYPE = {
  TEXT_INPUT: 'TEXT_INPUT',
  TEXT_AREA_INPUT: 'TEXT_AREA_INPUT',
  SELECT_INPUT: 'SELECT_INPUT',
  DROPDOWN_INPUT: 'DROPDOWN_INPUT',
  CHECK_BOX_INPUT: 'CHECK_BOX_INPUT',
  DATE_RANGE_PICKER_INPUT: 'DATE_RANGE_PICKER_INPUT',
  DATE_PICKER_INPUT: 'DATE_PICKER_INPUT',
  SEARCH_INPUT: 'SEARCH_INPUT',
  SEARCH_INPUT_WITH_OPTIONS: 'SEARCH_INPUT_WITH_OPTIONS',
  TOGGLE_INPUT: 'TOGGLE_INPUT',
  TEXT_WARNING: 'TEXT_WARNING',
  OPTION_MUTIL_CHOOSE: 'OPTION_MUTIL_CHOOSE',
  SIGNATURE_INPUT: 'SIGNATURE_INPUT',
  DOUBLE_TEXT_INPUT: 'DOUBLE_TEXT_INPUT',
};

const DEVICE_STATUS = {
  OFFLINE: 'Offline',
  PAUSED: 'Paused',
};

const STUDY_STATUS = {
  DRAFT: 'Draft',
  STARTING: 'Starting',
  ABORTED: 'Aborted',
  STARTED: 'Started',
  PAUSED: 'Paused',
  RESUMED: 'Resumed',
  COMPLETED: 'Completed',
  UPLOADING: 'Uploading',
  UPLOADED: 'Uploaded',
  ERASING: 'Erasing',
  ERASED: 'Erased',
  STOPPING: 'Stopping',
  ONGOING: 'Ongoing',
  DONE: 'Done',
};

const EMITTER_CONSTANTS = {
  UPDATE_TOTAL_EVENTS: 'UPDATE_TOTAL_EVENTS',
  UPDATE_EVENT_ECG: 'UPDATE_EVENT_ECG',
  STUDY_UPDATED_EVENT: 'STUDY_UPDATED_EVENT',
  EVENT_ROOM_USER: 'EVENT_ROOM_USER',
  REPORT_ROOM_USER: 'REPORT_ROOM_USER',
  REPORT_UPDATED: 'REPORT_UPDATED',
  LOGOUT_REQUEST: 'LOGOUT_REQUEST',
  EXPIRED_TOKEN: 'EXPIRED_TOKEN',
  NEW_SESSION: 'NEW_SESSION',
  UPDATE_NEW_EVENT_ECG: 'UPDATE_NEW_EVENT_ECG',
  GROUP_UPDATED: 'GROUP_UPDATED',
  UPDATE_OVERVIEW: 'UPDATE_OVERVIEW',
  // *: Report summary pagination
  BEAT_HR_NEXT: 'BEAT_HR_NEXT',
  BEAT_HR_PREV: 'BEAT_HR_PREV',
  // *: Rhythm event summary pagination
  RHYTHM_EVENTS_NEXT: 'RHYTHM_EVENTS_NEXT',
  RHYTHM_EVENTS_PREV: 'RHYTHM_EVENTS_PREV',
  // *:HOLTER REPORT
  HOLTER_GENERAL_ROOM: 'holterGeneral',
  HOLTER_PROFILE_ROOM: 'holter-{profileId}',
  HOLTER_PROFILE_UPDATED: 'HOLTER_PROFILE_UPDATED',
  TECHNICIAN_COMMENT_UPDATED: 'TECHINICIAN_COMMENT_UDAPTED',
  RR_CELL_REVIEWED: 'RR_CELL_REVIEWED',
  PROFILE_READY: 'PROFILE_READY',
  BEATSUPDATED_EVENT: 'BEATSUPDATED_EVENT',
  EVENTSUPDATED_EVENT: 'EVENTSUPDATED_EVENT',
  RR_HISTOGRAM_UPDATED_EVENT: 'RR_HISTOGRAM_UPDATED_EVENT',
  DAILY_SUMMARY_UPDATED: 'DAILY_SUMMARY_UPDATED',
  AFIB_HR_SUMMARY_UPDATED: 'AFIB_HR_SUMMARY_UPDATED',
  COMMAND_PROGRESS_UPDATED: 'COMMAND_PROGRESS_UPDATED',
  COMMAND_EXECUTED: 'COMMAND_EXECUTED',
  COMMAND_PENDING: 'COMMAND_PENDING',
  UPDATE_PENDING_PROFILES: 'UPDATE_PENDING_PROFILES',
  RR_HEATMAP_UPDATED: 'RR_HEATMAP_UPDATED',
  AI_PROCESS_SAVED: 'AI_PROCESS_SAVED',
  UPDATE_TOKEN_LOCAL_STORAGE: 'UPDATE_TOKEN_LOCAL_STORAGE',
  MINUTELY_HR_UPDATED: 'MINUTELY_HR_UPDATED',
  AI_STOP_PROCESSING: 'AI_STOP_PROCESSING',
  STOP_SAVING: 'STOP_SAVING',
  SAVING_STATUS: 'SAVING_STATUS',
  RESET_STUDY: 'RESET_STUDY',

  // Save AI holter report
  AI_LOADING: 'AI_LOADING',
  AI_UPDATE_TAB: 'AI_UPDATE_TAB',
  AI_REPORT_LOADING: 'AI_REPORT_LOADING',

  // Socket, Internet disconnect
  LOST_CONNECTION: 'LOST_CONNECTION',
  UPDATE_HEATMAP_CHART_DATA: 'UPDATE_HEATMAP_CHART_DATA',
  UPDATE_RELOAD_BEAT: 'UPDATE_RELOAD_BEAT',
  UPDATE_SET_LIST_ORIGIN_REVIEWED_CELLS_STATUS: 'UPDATE_SET_LIST_ORIGIN_REVIEWED_CELLS_STATUS',
  STRIP_MANAGEMENT_NEXT: 'STRIP_MANAGEMENT_NEXT',
  STRIP_MANAGEMENT_PREV: 'STRIP_MANAGEMENT_PREV',
  STRIP_DEVICE_MANAGEMENT_NEXT: 'STRIP_DEVICE_MANAGEMENT_NEXT',
  STRIP_DEVICE_MANAGEMENT_PREV: 'STRIP_DEVICE_MANAGEMENT_PREV',
  UPDATE_EVENT_SUCCESS: 'UPDATE_EVENT_SUCCESS',
  OPEN_MODAL_EDIT_AI_STRIP: 'OPEN_MODAL_EDIT_AI_STRIP',
  RELOAD_EVENT_STRIP: 'RELOAD_EVENT_STRIP',
  UPDATE_CAPTURE_EVENT: 'UPDATE_CAPTURE_EVENT',
  // Current Index for Undo Redo function
  UNDO_REDO_CURRENT_INDEX: 'UNDO_REDO_CURRENT_INDEX',
  VERIFY_ALL_BEAT_FILES_DOWNLOADED: 'VERIFY_ALL_BEAT_FILES_DOWNLOADED',

  STOP_AI_PROCESSING: 'STOP_AI_PROCESSING',
  UPDATE_SOCKET_BEAT_DATA_MAP: 'UPDATE_SOCKET_BEAT_DATA_MAP',
  MIGRATE_AI_DATA_VER1_TO_VER2: 'MIGRATE_AI_DATA_VER1_TO_VER2',
  RE_CAPTURE_EVENTS: 'RE_CAPTURE_EVENTS',
  BEATS_TEMPLATE_NEXT: 'BEATS_TEMPLATE_NEXT',
  BEATS_TEMPLATE_PREV: 'BEATS_TEMPLATE_PREV',
  UPDATE_DATA_SAVING: 'UPDATE_DATA_SAVING',
  RELOAD_TEMPLATE_BEATS_MORPHOLOGY: 'RELOAD_TEMPLATE_BEATS_MORPHOLOGY',
  RESET_CACHES: 'RESET_CACHES',
  SITE_UNDER_MAINTENANCE: 'SITE_UNDER_MAINTENANCE',
  WILL_CLEAR_CACHE_TEMPLATE: 'WILL_CLEAR_CACHE_TEMPLATE',
  WILL_CLEAR_CACHE: 'WILL_CLEAR_CACHE',
  INBOX: 'INBOX',
  RE_CAPTURE_AUTO_EVENTS: 'RE_CAPTURE_AUTO_EVENTS',
  RE_RENDER_HR_CHART: 'RE_RENDER_HR_CHART',
  RE_RENDER_ECG_VIEWER: 'RE_RENDER_ECG_VIEWER',
  RE_MIGRATE_FILE_DOWNLOAD_403: 'RE_MIGRATE_FILE_DOWNLOAD_403',
  SOCKET_CONNECTED: 'SOCKET_CONNECTED',
  SOCKET_ATTACH_LISTENERS: 'SOCKET_ATTACH_LISTENERS',
  SOCKET_DISCONNECTED: 'SOCKET_DISCONNECTED',
  SOCKET_RECONNECTED: 'SOCKET_RECONNECTED',
  SOCKET_RECONNECT_FAILED: 'SOCKET_RECONNECT_FAILED',
  MAINTENANCE_CHANGED: 'MAINTENANCE_CHANGED',
  PAGE_CRASHED: 'PAGE_CRASHED',
  REMOVE_SELECTED_CELLS: 'REMOVE_SELECTED_CELLS',
  RELOAD_TEMPLATE_OVERVIEW: 'RELOAD_TEMPLATE_OVERVIEW',
  ENABLE_UPDATE_FINDINGS: 'ENABLE_UPDATE_FINDINGS',
};

const CONNECTION_TYPE = {
  NETWORK: 'NETWORK',
  SOCKET: 'SOCKET',
};

const UTC_US_STANDARD_TIME = [
  {
    utc: 'UTC-5',
    name: 'EST',
  },
  {
    utc: 'UTC-6',
    name: 'CST',
  },
  {
    utc: 'UTC-7',
    name: 'MST',
  },
  {
    utc: 'UTC-8',
    name: 'PST',
  },
  {
    utc: 'UTC-9',
    name: 'AKST',
  },
  {
    utc: 'UTC-10',
    name: 'HAST',
  },
];

const UTC_US_DAYLIGHTT_TIME = [
  {
    utc: 'UTC-4',
    name: 'EDT',
  },
  {
    utc: 'UTC-5',
    name: 'CDT',
  },
  {
    utc: 'UTC-6',
    name: 'MDT',
  },
  {
    utc: 'UTC-7',
    name: 'PDT',
  },
  {
    utc: 'UTC-8',
    name: 'AKDT',
  },
  {
    utc: 'UTC-9',
    name: 'HADT',
  },
];

const ROOM_FACILITY = {
  FACILITY_TEST_ROOM: 'testCallCenter',
  FACILITY_ROOM: 'activeCallCenter',
};

const ARTIFACT_REPORT_HOVER_TEXT = 'Report is marked as artifact';

const STUDY_HAS_ARTIFACT_REPORT_HOVER_TEXT = 'This study has report marked as artifact';

const MESSAGE_ARTIFACT_REPORT =
  'This report could not be generated due to all data being artifact. Please ensure you are checking ECG connection when starting a study';
const MESSAGE_ARTIFACT_REPORT_CALLCENTER =
  'Most of study data are artifacts, the report could not be generated';

const HIHT_SAMPLING_RATE_DEVICE_MESSAGE = 'This device is operating at a high sampling rate';

const URL_ERP_PORTAL =
  window.location.hostname === 'localhost'
    ? 'http://localhost:3001'
    : ENV === ENV_ENUM.alpha
      ? 'https://erp.alpha.bioflux.io'
      : ENV === ENV_ENUM.delta
        ? 'https://erp.delta.bioflux.io'
        : ENV === ENV_ENUM.staging
          ? 'https://erp.staging.biotricity.com'
          : 'https://erp.customer.biotricity.com';
// use when develop on local
// const URL_ERP_PORTAL = 'http://localhost:3001'

const URL_CALLCENTER_PORTAL = {
  [ENV_ENUM.alpha]: 'https://callcenter.alpha.bioflux.io/',
  [ENV_ENUM.delta]: 'https://callcenter.delta.bioflux.io/',
  [ENV_ENUM.staging]: 'https://callcenter.staging.biotricity.com/',
  [ENV_ENUM.customer]: 'https://callcenter.customer.biotricity.com/',
}[ENV];

const ERROR_ACTION = {
  REDIRECT: 'redirect',
  LOGOUT: 'logout',
  EXPIRE_TOKEN: 'expireToken',
  CHANGE_ROLE: 'changeRole',
};

const REPORT_TYPES = {
  INTERIM: 'Interim',
  STUDY: 'Study',
  UNREVIEWED: 'UNREVIEWED',
  AI_EOU: 'AI EOU',
};

const TEMPLATE_TYPE = {
  V: 'V',
  S: 'S',
};

const CLIENT_NAMES = ['ai-report-processing-desktop'];

const AUTH_MODE = {
  SSO: 'sso',
  USERNAME_PASSWORD: 'username_password',
};

const AUTH_PRESERVED_LOCAL_STORAGE_KEYS = [
  'keyBeatDataStatus',
  'ai_process-*',
  'requestId-*',
  'ai_saving-*',
];

const REPORT_FORMAT_VERSION = {
  V202: '2.0.2',
};

const CHARACTER_PER_LINE = 80;

const TIME_TRACKING_EMITTER_CONSTANTS = {
  API_TRACKING: 'API_TRACKING',
};

export {
  AUTH_MODE,
  AUTH_PRESERVED_LOCAL_STORAGE_KEYS,
  ARTIFACT_REPORT_HOVER_TEXT,
  CHARACTER_PER_LINE,
  CLIENT_NAMES,
  CONNECTION_TYPE,
  DEVICE_STATUS,
  EMITTER_CONSTANTS,
  ERROR_ACTION,
  FULL_EVENT_TYPE_OPTIONS,
  HIHT_SAMPLING_RATE_DEVICE_MESSAGE,
  INPUT_TYPE,
  MESSAGE_ARTIFACT_REPORT,
  MESSAGE_ARTIFACT_REPORT_CALLCENTER,
  REPORT_FORMAT_VERSION,
  REPORT_TYPES,
  ROOM_FACILITY,
  STUDY_HAS_ARTIFACT_REPORT_HOVER_TEXT,
  STUDY_STATUS,
  STUDY_TYPE,
  TEMPLATE_TYPE,
  TIME_TRACKING_EMITTER_CONSTANTS,
  URL_CALLCENTER_PORTAL,
  URL_ERP_PORTAL,
  UTC_US_DAYLIGHTT_TIME,
  UTC_US_STANDARD_TIME,
};
